import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./index.css";
import { cToF } from "../../utils";

type SetTemperatureProps = {
  value: number;
  onTouchEnd?(value: number): void;
  style?: React.CSSProperties | undefined;
  rangeData?: number[];
  min?: number;
  max?: number;
  unit?: 'C' | 'F' | undefined
};

function SetTemperature(props: SetTemperatureProps) {
  // 滑杆使用离散温度档位，鼠标和触摸最终都要提交到同一条回调链路。
  const validValues = useMemo(() => props.rangeData || [], [props.rangeData]);
  const [index, setIndex] = useState(0);
  const lastCommittedIndexRef = useRef<number | null>(null);

  const safeIndex = useMemo(() => {
    if (!validValues.length) {
      return 0;
    }
    return Math.min(Math.max(index, 0), validValues.length - 1);
  }, [index, validValues]);

  const value = validValues[safeIndex];

  const onChange = (event: any) => {
    const newValueIndex = Number(event.target.value);
    setIndex(Number.isFinite(newValueIndex) ? newValueIndex : 0);
  };

  const commitValue = useCallback(() => {
    if (!props.onTouchEnd || !validValues.length) {
      return;
    }

    if (lastCommittedIndexRef.current === safeIndex) {
      return;
    }

    lastCommittedIndexRef.current = safeIndex;
    props.onTouchEnd(validValues[safeIndex]);
  }, [props, safeIndex, validValues]);

  const unit = props.unit === 'F' ? '℉' : '℃'

  useEffect(() => {
    const nextIndex = validValues.indexOf(props.value);
    const resolvedIndex = nextIndex >= 0 ? nextIndex : 0;
    setIndex(resolvedIndex);
    lastCommittedIndexRef.current = resolvedIndex;
  }, [props.value, validValues]);

  return (
    <div
      className="text-white border-4 border-white rounded-3xl font-black text-3xl h-40  bg-quickStartLeftStepContentBgColor w-[700px]"
      style={{
        ...(props.style || {}),
      }}
    >
      <div className="font-bold text-3xl text-center mt-2">Set Temperature</div>
      <div className="w-9/12 mt-5 inline-block ml-6 ">
        <input
          className="set-temperature-range"
          type="range"
          value={safeIndex}
          min={0}
          max={Math.max(validValues.length - 1, 0)}
          onChange={onChange}
          onMouseUp={commitValue}
          onPointerUp={commitValue}
          onTouchEnd={commitValue}
          step={1}
        />
        <div className="w-full">
          <span className="text-lg inline-block float-left">
            {unit === '℉' ? cToF(validValues[0]) : validValues[0]}{unit}
          </span>
          <span className="text-lg inline-block float-right mr-5">
            +{unit === '℉' ? cToF(validValues[validValues.length - 1]) : validValues[validValues.length - 1]}{unit}
          </span>
        </div>
      </div>
      <div className="inline-block text-white font-bold text-5xl ml-2 absolute mt-3">
        {(unit === '℉' ? cToF(value) : value) + unit}
      </div>
    </div>
  );
}
export default SetTemperature;
